import Head from 'next/head'

export default function MetaData({ title: titleFromProps, description: descFromProps, image }) {
  const title =
    titleFromProps ||
    'Медицинский центр в Минске «Sante» — частный многопрофильный медицинский центр в городе Минск'
  const description =
    descFromProps ||
    'Медицинский центр «Sante» оказывает полный перечень услуг по диагностике и лечению всех видов заболеваний. Высокое качество обслуживания, низкие цены.'

  const ogImage = image?.og
  const twitterImage = image?.twitter

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />

      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />

      {ogImage && (
        <>
          <meta property="og:image" content={ogImage} />
          <meta property="og:image:secure_url" content={ogImage} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </>
      )}

      {twitterImage && (
        <>
          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:image" content={twitterImage} />
        </>
      )}

    </Head>
  )
}
